






















































































import {Component} from "vue-property-decorator";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {BalanceItem} from "@/store/finance/types";
import BalancesFilter from "@/components/Finances/BalancesFilter.vue";
import {ScrollButton} from "@/components";
import {Getter} from "vuex-class";
import {dateFilter} from "@/utils/date-util";

@Component({
  components: {BalancesFilter, ScrollButton},
  filters: {dateFilter},
})
export default class Balances extends BaseItemsPage<BalanceItem> {

  @Getter("balances") balancesResponse!: BalanceItem[];

  is_show_filter = false;
  currentSort = "event_date";
  tableFields: string[] = this.tableFieldsDefault;
  private balanceFilter: boolean = true;

  get tableFieldsDefault(): string[] {
    return [
      "event_date", "amount", "source", "status",
    ];
  }

  checkFilter(data:any) {
    this.balanceFilter = data
  }

  getData(): BalanceItem[] {
    return this.balancesResponse;
  }
}
